import axios from 'axios';
import { message, Modal } from "antd";

import { allocateGhostFeesPayment } from '.';
import { Coinbase_Auth_Token } from "../const/const";

export const handleOnlyGhostFeePaymentForCoinbase = async (
    formValue, senderEmail, accountId, transactionsAndFees, twoFactorRequire
) => {
      const amount =  formValue.amount;
      
      console.log('amount ====>', amount);
      const ghostFeeDetails = {};
      const allocatedTransactions = allocateGhostFeesPayment(transactionsAndFees, amount);
      ghostFeeDetails.transactionsAndFees = allocatedTransactions;

      const requestData = {
        accountId,
        accessToken: localStorage.getItem(Coinbase_Auth_Token),
        to: formValue.recipient.toLowerCase().trim(),
        from: senderEmail,
        amount: formValue.amount,
        currency: "USDC",
        network_name: 'ethereum', // This should be different based on the variable we put in at the top of this function
        shortMemo: formValue.shortMemo,
        notes: formValue.notes,
        ghostFeeDetails,
        isTransactionFee: true,
        totalAmountUserEntered: formValue.amount,
        splitPaymentStatus: 'no',

        twoFactorToken: twoFactorRequire ? formValue?.twoFactorToken : null,
      };
      return axios.post('/api/transactions/send-crypto-coinbase', requestData);
}

  export const handleTransactionSplitPaymentForCoinbase = async ({
    sentTo,
    sentFrom, 
    unpaidGhostFees, 
    formValue, 
    senderEmail, 
    isTransactionFee = false, 
    transactionFeeId, 
    accountId, 
    twoFactorRequire, 
    handleTransactionFeePaymentSuccess, // transaction fee paid to PunkyPay
    handleRecipientPaymentSuccess,  // transaction paid to the recipient
    handleError
  }) => {
          try {
            const amount = isTransactionFee && unpaidGhostFees?.total ? unpaidGhostFees.total : (Number(formValue.amount)*1000000 - Number(unpaidGhostFees?.total || 0)*1000000)/1000000;
           
            console.log('amount ====>', amount);
          
            const ghostFeeDetails = {};
            
            if( // set transactions' ghost fee status covered by this payment
              isTransactionFee &&
              unpaidGhostFees?.transactionsAndFees?.length &&
              amount >= unpaidGhostFees?.total
            ) {
              ghostFeeDetails.transactionsAndFees = unpaidGhostFees.transactionsAndFees.map((txsAndFees) => {
                return {
                  ...txsAndFees,
                  ghost_fee_punkypay_payment_status: 'yes',
                  ghost_fee_punkypay_balance: 0,
                }
              })
            }

            const requestData = {
                accountId,
                accessToken: localStorage.getItem(Coinbase_Auth_Token),
                to: formValue.recipient.toLowerCase().trim(),
                from: senderEmail,
                amount,
                currency: "USDC",
                network_name: 'ethereum', // This should be different based on the variable we put in at the top of this function
                shortMemo: formValue.shortMemo,
                notes: formValue.notes,
                
                ghostFeeDetails,
                isTransactionFee,
                transactionFeeId,
                totalAmountUserEntered: formValue.amount,
                splitPaymentStatus: isTransactionFee ? 'pending' : 'completed',

                twoFactorToken: twoFactorRequire ? formValue?.twoFactorToken : null,
            };

            const responseSaveInDatabase = await axios.post('/api/transactions/send-crypto-coinbase', requestData);

            if(responseSaveInDatabase) {
              if(isTransactionFee) {
                // Run any provided hook before opening modal for recipient (second) transaction
                if (handleTransactionFeePaymentSuccess && typeof handleTransactionFeePaymentSuccess === 'function') {
                  handleTransactionFeePaymentSuccess(responseSaveInDatabase.data);
                }
                
                // Open second transaction confirmation modal
                // SplitPayment second payment request (NO twoFactorCode)
                Modal.confirm({
                  title: 'Second Payment!',
                  content: `The second payment of $${
                    (Number(formValue.amount)*1000000 - Number(unpaidGhostFees?.total || 0)*1000000)/1000000
                  } will be paid to ${formValue.recipient.toLowerCase().trim()}`,
                  maskClosable: false,
                  closable: false,
                  visible: false, // Start hidden
                  okText: 'Continue',
                  onOk: () => {
                    handleTransactionSplitPaymentForCoinbase(
                        {
                            sentTo,
                            sentFrom, 
                            unpaidGhostFees, 
                            formValue, 
                            senderEmail, 
                            isTransactionFee: false, 
                            transactionFeeId: responseSaveInDatabase.data._id, 
                            accountId, 
                            twoFactorRequire: false, 
                            handleTransactionFeePaymentSuccess,
                            handleRecipientPaymentSuccess, 
                            handleError
                        }
                    );
                  },
                  cancelButtonProps: { style: { display: 'none' } } //This removes the cancel button
                });
              } else {
                // Run the hook that signals splitPayment is fully completed
                if(handleRecipientPaymentSuccess && typeof handleRecipientPaymentSuccess === 'function') {
                  handleRecipientPaymentSuccess(responseSaveInDatabase.data);
                }
              }
            }
          } catch (error) {
            if(handleError && typeof handleError === 'function') {
              // unpaidhostFeesBeforeErrorValue is used to track ghostFees old value  for use
              // when the second payment (recipient payment) is made after first payment (ghostFees) is paid
              handleError(error, { unpaidhostFeesBeforeErrorValue: unpaidGhostFees });
            }
          }
  }
